import React, {useEffect} from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import book from '../../images/book.png';
import home_therapy from '../../images/home-therapy.png';
import calling from '../../images/calling.png';
import './Steps.css'
import { useNavigate } from 'react-router-dom';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function Steps({isStepsPopupVisible,toggleStepsPopup}) {
  const navigate = useNavigate();

  useEffect(() => {
      window.scrollTo(0, 0);
  });

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={toggleStepsPopup}
        aria-labelledby="customized-dialog-title"
        open={isStepsPopupVisible}
        maxWidth="lg"
        sx={{ mb: 4, zIndex: 11 }}
      >
        <IconButton
          aria-label="close"
          onClick={toggleStepsPopup}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
            zIndex: 15
          })}
        >
          <CancelIcon />
        </IconButton>
        <DialogContent dividers>
            <h1 className='stepTitle'>How Does MantraFlex In-Home Physiotherapy Work?</h1>
            <hr/>
            <p className='introLine'>
                In-Home Therapeutics streamlines access to in-home physiotherapy services in Ottawa, offering a hassle-free process 
                that makes scheduling and managing treatments simple and convenient.
            </p>
            <div className='steps'>
                <div className='step'>
                    <div className='step-heading'>
                        <div>Step 1</div>
                    </div>
                    <div className='step-img'>
                      <img src={book} alt=''/>
                    </div>
                    <div className='step-intro'>
                      <p>
                        Book an Appointment here
                      </p>
                      <button className="button primary" onClick={() => window.location.href = 'https://mantraflexinc.janeapp.com/'}>Book Appointment</button>
                    </div>
                </div>
                <div className='step'>
                    <div className='step-heading'>
                        <div>Step 2</div>
                    </div>
                    <div className='step-img'>
                      <img src={calling} alt=''/>
                    </div>
                    <div className='step-intro'>
                      <p>
                        We will contact you to know more about you and schedule an appointment if not scheduled yet or alter the 
                        appointment if needed.
                      </p>
                    </div>
                </div>
                <div className='step'>
                <div className='step-heading'>
                        <div>Step 3</div>
                    </div>
                    <div className='step-img'>
                      <img src={home_therapy} alt=''/>
                    </div>
                    <div className='step-intro'>
                      <p>
                        Your physiotherapist will come to your home to initiate your treatment plan and guide you toward improved 
                        health and mobility.
                      </p>
                    </div>
                </div>
            </div>
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
